import {DomSanitizer} from '@angular/platform-browser';
import {Component} from '@angular/core';
import {MENU_ENDPOINT, MenuItem} from './shell/menu/menu.component';
import {ApiService} from './api/api.service';
import {TranslationInputService} from './basic-entity-back/services/translation-input.service';
import {Idioma} from './model/localizacion/idioma.model';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {MatDialogRef} from '@angular/material/dialog';
import {MatDrawer} from '@angular/material/sidenav';
import {SessionService} from './session/session.service';
import {ErrorDisplayService} from './basic-entity-front/services/error-display.service';
import {SimpleDialogService} from './basic-entity-front/dialog-shell/simple-dialog.service';
import {Router} from '@angular/router';
import {MatIconRegistry} from '@angular/material/icon';
import {DeviceDetectorService} from './services/device-detector.service';
import {HttpRequestService} from "./shell/loading/http-request.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    public menuItems: MenuItem[] = [];
    // public isHandset: boolean = window.matchMedia('only screen and (max-width: 768px)').matches;
    public isHandset$: Observable<boolean> = this.deviceDetector.isHandset();
    private _sessionService: SessionService;
    private _networkDialogRef: MatDialogRef<any> = null;
    cargando = false;
    mostrarCargando = false;

    constructor(private _api: ApiService,
                translation: TranslationInputService,
                sessionService: SessionService,
                dialogService: SimpleDialogService,
                private router: Router,
                public errorService: ErrorDisplayService,
                public breakpointObserver: BreakpointObserver,
                private matIconRegistry: MatIconRegistry,
                private deviceDetector: DeviceDetectorService,
                private domSanitizer: DomSanitizer,
                private httpRequestService: HttpRequestService) {
        this._sessionService = sessionService;
        this.matIconRegistry.addSvgIcon(
            'airbnb_svg',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/img/airbnb.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'de_svg',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/img/de_negativo_azul.svg')
        );
        this._updateMenu();
        sessionService
            .sessionChanges
            .subscribe(() => {
                this._updateMenu();
                if (!sessionService.isLogged()) {
                    router.navigate(['.']);
                }
            }, err => errorService.displayError(err));
        translation.initialise(Idioma);
        translation.preload();

        window.addEventListener('offline', () => {
            this._networkDialogRef = dialogService.simpleDialog(
                'Sin conexión',
                'Esta web no puede operar sin conexión a internet.',
                [], true, false);
        });
        window.addEventListener('online', () => {
            if (this._networkDialogRef) {
                this._networkDialogRef.close();
                this._networkDialogRef = null;
            }
        });

        window.addEventListener("beforeunload", (e) => {
            localStorage.setItem('tabId', window['tabId']);
            return null;
        });

        window.addEventListener("load", (e) => {
            if (localStorage.getItem('tabId')) {
                window['tabId'] = localStorage.tabId;
                localStorage.removeItem("tabId");
            } else {
                window['tabId'] = Math.floor(Math.random() * 1000000);
            }
            return null;
        });
    }

    ngOnInit(): void {
        // Solo muestro el cargando en estas páginas
        this.router.events.subscribe((event) => {
            this.mostrarCargando = this._sessionService.isLogged() && this.router.url.indexOf('historico') === -1 && (this.router.url.indexOf('pedidos') > -1 || this.router.url.indexOf('solicitudes') > -1 || this.router.url.indexOf('produccion') > -1);
            this.mostrarCargando = this.mostrarCargando && this.router.url.indexOf('validacion_solicitud') === -1;
            this.mostrarCargando = this.mostrarCargando && this.router.url.indexOf('piezas') === -1;
            this.mostrarCargando = this.mostrarCargando && this.router.url.indexOf('incidencias') === -1;
            this.mostrarCargando = this.mostrarCargando && this.router.url.indexOf('centros') === -1;
        });

        // Suscribirse al observable de isLoading para detectar cambios en el estado de las solicitudes
        this.httpRequestService.isLoading$.subscribe(isLoading => {
            this.cargando = isLoading;
        });
    }


    public menuItemClicked(drawer: MatDrawer) {
        if (!(this.breakpointObserver.isMatched(Breakpoints.XLarge) || this.breakpointObserver.isMatched(Breakpoints.Large))) {
            drawer.close();
        }
    }

    private _updateMenu() {

        if (this._sessionService.isLogged()) {
            this._api.getCollection<MenuItem>(MENU_ENDPOINT)
                .pipe(ApiService.sTakeBody())
                .subscribe(menuItems => {
                    console.log(menuItems)
                    this.menuItems = menuItems.member.filter(item => {
                        item.children = item.children.filter(child => child.notForEmployee === false);
                        return item.notForEmployee === false
                    });
                }, err => this.errorService.displayError(err));
        }
    }

    public isLogged(): boolean {
        return this._sessionService.isLogged();
    }


}
